import { BriefType, SmartBriefConversation } from './smart-brief-conversation';

export const BRIEF_TYPE_CARD_TITLE: Record<BriefType, string> = {
  ugc: 'UGC Content Brief',
  screening: 'Social Screening Brief',
  monitoring: 'Social Monitoring Brief',
};

const FOLLOW_UP_LEAD: Record<BriefType, string> = {
  ugc: 'Great, a UGC brief.',
  screening: 'Got it, a social screening brief.',
  monitoring: 'Got it, a social monitoring brief.',
};

const FOLLOW_UP_REST =
  ' Add your brief below: type it out, drop in a document or paste a Google Doc link. Or I can help you write it.';

export type OpeningMessage =
  | { kind: 'greeting'; name: string; rest: string }
  | { kind: 'choice'; text: string }
  | { kind: 'follow-up'; text: string };

/** The opening exchange implied by the conversation. A chosen type includes the reply and the follow-up. */
export function openingThread(conversation: SmartBriefConversation, firstName: string): OpeningMessage[] {
  const name = firstName.trim();
  const messages: OpeningMessage[] = [
    {
      kind: 'greeting',
      name,
      rest: ' What kind of brief are you creating?',
    },
  ];
  const briefType = conversation.draft.briefType;
  if (!briefType) {
    return messages;
  }
  messages.push({ kind: 'choice', text: BRIEF_TYPE_CARD_TITLE[briefType] });
  messages.push({ kind: 'follow-up', text: `${FOLLOW_UP_LEAD[briefType]}${FOLLOW_UP_REST}` });
  return messages;
}
